import { Component, OnInit, ViewEncapsulation, Inject, ElementRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DDeclaracionSugerida } from '@dian-api/iva300v4';

@Component({
  selector: 'app-dialogo-editar-declaracion-sugerida',
  templateUrl: './dialogo-editar-declaracion-sugerida.component.html',
  styleUrls: ['./dialogo-editar-declaracion-sugerida.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoEditarDeclaracionSugeridaComponent implements OnInit {

	public seccionError1: boolean = false;
	public seccionError2: boolean = false;
	public seccionError3: boolean = false;
	public seccionError4: boolean = false;
	public seccionError5: boolean = false;
	public seccionError6: boolean = false;
	public seccionError7: boolean = false;
	public seccionError8: boolean = false;

  constructor(
  	public dialogRef: MatDialogRef<DialogoEditarDeclaracionSugeridaComponent>, 
    @Inject(MAT_DIALOG_DATA) private declaracionSugerida: DDeclaracionSugerida,    
    private dnotificaciones: DNotificacionServicio,
    private dutilidades:DOperacionesMatematicasServicio
  ) {

  }

  ngOnInit() {
  }

  //Menor Casilla 27 + Casilla 38 = Ingresos 5% sugerido
  validarCasillaSec1(): boolean{
  	let cas27 = this.declaracionSugerida.valSugeridoCasilla27;
  	let cas38 = this.declaracionSugerida.valSugeridoCasilla38;
  	let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas27, cas38);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIngresoEsp)) {
  		this.seccionError1 = true;
  		return false;
  	}
  	this.seccionError1 = false;
  	return true;	
  }

	//Menor	Casilla 28 + Casilla 36 + Casilla 37 = Ingresos general sugerido
  validarCasillaSec2(): boolean {
  	let cas28 = this.declaracionSugerida.valSugeridoCasilla28;
  	let cas36 = this.declaracionSugerida.valSugeridoCasilla36;
    let cas37 = this.declaracionSugerida.valSugeridoCasilla37;
    let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas28, cas36);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, cas37);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);  	
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIngresoGen)) {
  		this.seccionError2 = true; 
  		return false;
  	}
  	this.seccionError2 = false; 
  	return true;
  }

  //Mayor Casilla 50 + Casilla 52 = Compras 5% sugerido
  validarCasillaSec3(): boolean {
  	let cas50 = this.declaracionSugerida.valSugeridoCasilla50;
  	let cas52 = this.declaracionSugerida.valSugeridoCasilla52;
  	let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas50, cas52);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoComprasEsp)) {
  		this.seccionError3 = true; 
  		return false;
  	}
  	this.seccionError3 = false; 
  	return true;
  }

  //Mayor Casilla 51 + Casilla 53 = Compras general sugerido
  validarCasillaSec4(): boolean {
  	let cas51 = this.declaracionSugerida.valSugeridoCasilla51;
  	let cas53 = this.declaracionSugerida.valSugeridoCasilla53;
    let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas51, cas53);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);  	
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoComprasGen)) {
  		this.seccionError4 = true; 
  		return false;
  	}
  	this.seccionError4 = false; 
  	return true;
  }

  //Menor Casilla 58 + Casilla 64 = Generado 5% sugerido
  validarCasillaSec5(): boolean {
  	const cas58 = this.declaracionSugerida.valSugeridoCasilla58;
  	const cas64 = this.declaracionSugerida.valSugeridoCasilla64;
    let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas58, cas64);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);      	
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIvagenEsp)) {
  		this.seccionError5 = true; 
  		return false;
  	}
  	this.seccionError5 = false; 
  	return true;
  }

  //Menor Casilla 59 + Casilla 62 + Casilla 63 = Generado sugerido
  validarCasillaSec6(): boolean {
  	let cas59 = this.declaracionSugerida.valSugeridoCasilla59;
  	// let cas61 = this.declaracionSugerida.valSugeridoCasilla61;
  	let cas62 = this.declaracionSugerida.valSugeridoCasilla62;
  	let cas63 = this.declaracionSugerida.valSugeridoCasilla63;
    // Se quita de la suma la casilla 61
    // let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas59, cas61);
    let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas59, cas62);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, cas63);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);              	
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIvagenGen)) {
  		this.seccionError6 = true; 
  		return false;
  	}
  	this.seccionError6 = false; 
  	return true;
  }

  //Mayor Casilla 71 + Casilla 73 + Casilla 74 = Descontable 5%
  validarCasillaSec7(): boolean {
  	let cas71 = this.declaracionSugerida.valSugeridoCasilla71;
  	let cas73 = this.declaracionSugerida.valSugeridoCasilla73;
  	let cas74 = this.declaracionSugerida.valSugeridoCasilla74;
  	let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas71, cas73);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, cas74);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);     
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIvadesEsp)) {
  		this.seccionError7 = true;
  		return false;
  	}
  	this.seccionError7 = false; 
  	return true;
  }

  //Mayor Casilla 72 + Casilla 75 + Casilla 76 = Descontable 19%
  validarCasillaSec8(): boolean {
  	let cas72 = this.declaracionSugerida.valSugeridoCasilla72;
  	let cas75 = this.declaracionSugerida.valSugeridoCasilla75;
  	let cas76 = this.declaracionSugerida.valSugeridoCasilla76;
  	let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas72, cas75);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, cas76);
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma,true);     
  	if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, valorRedondeado, this.declaracionSugerida.valSugeridoIvadesGen)){
  		this.seccionError8 = true;
  		return false;
  	}
  	this.seccionError2 = false; 
  	return true;
  }

  mostrarMensajeNoValido(mensajes:string) {
 		const dialogoConfirmacion = this.dnotificaciones.mostrarDialogoConfirmacion("La sumatoria de la distribución no coincide con el valor sugerido en las siguientes secciones: <ol>"+mensajes+"</ol>.<br> ¿Está seguro del ingreso de su distribución?");
 		dialogoConfirmacion.afterClosed().subscribe(
 			res => {
        if(res){
          this.dialogRef.close(this.declaracionSugerida);
        }
 			}
 		);
  }

  validarDistribucion() {
    let val1 = this.validarCasillaSec1();
    let val2 = this.validarCasillaSec2();
    let val3 = this.validarCasillaSec3();
    let val4 = this.validarCasillaSec4();
    let val5 = this.validarCasillaSec5();
    let val6 = this.validarCasillaSec6();
    let val7 = this.validarCasillaSec7();
    let val8 = this.validarCasillaSec8();
  	if (
      val1 &&
      val2 &&
      val3 &&
      val4 &&
      val5 &&
      val6 &&
      val7 &&
      val8
		) {this.dialogRef.close(this.declaracionSugerida);}
		else{
      let mensajes="";
      if(!val1){
        mensajes = mensajes + "<li>Sección Ingreso 5% sugerido</li>";
      }
      if(!val2){
        mensajes = mensajes + "<li>Sección Ingresos general sugerido</li>";
      }      
      if(!val3){
        mensajes = mensajes + "<li>Sección Compras 5% sugerido</li>";
      }
      if(!val4){
        mensajes = mensajes + "<li>Sección Compras Compras general sugerido</li>";
      }
      if(!val5){
        mensajes = mensajes + "<li>Sección Generado 5% sugerido</li>";
      } 
      if(!val6){
        mensajes = mensajes + "<li>Sección Generado sugerido</li>";
      }
      if(!val7){
        mensajes = mensajes + "<li>Sección Descontable 5%</li>";
      }
      if(!val8){
        mensajes = mensajes + "<li>Sección Descontable 19%</li>";
      }      

      this.mostrarMensajeNoValido(mensajes);
    }		    
  }

  /**
   * @desc Funcion para cambiar el foco de los input
   * @function processKeyUp
   * @ignore
   * @param {Event} e evento que contiene el keycode
   * @param {HtmlElement} el a pasar el foco
   * @param {boolean} remover foco cuando no hay mas donde pasar el foco para que la casilla se formatie, entonces ejecuta el evento blur
   * es necesario que el parametro el apunte al el mismo elemento que esta llamando la funci�n
   */
  private cambioFocoCasillas(e, el, remover?:boolean) {
    if (!remover) {
      if (e.keyCode == 13) el.focus();
    } else el.blur();
  }
}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-editar-declaracion-sugerida/dialogo-editar-declaracion-sugerida.component.ts